import axios from "axios";

const api = () => {
  const instance = axios.create({
    baseURL: process.env.NEXT_PUBLIC_MAD_UNICORN_BASE_URL,
    timeout: 15000,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  instance.interceptors.request.use(async (request) => {
    request.headers.Authorization = `Api-Key ${process.env.NEXT_PUBLIC_MAD_UNICORN_API_KEY}`;

    return request;
  });
  return instance;
};

export default api();
